import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import { LanguageItem, Subtitle } from 'app/components/library/mediaclip/subtitle-quickedit.component';
import { SapiService } from './sapi.service';
import { BBPlayerAPI } from 'app/interfaces/bb-player-api';

@Injectable()
export class SubtitleService {
	public languagesSubject = new ReplaySubject<LanguageItem[]>(1);
	public uploadedSrtSubject = new ReplaySubject<string>(1);
	public subtitleSubject = new Subject<Subtitle>();

	public currentTimeSubject = new ReplaySubject<number>(0);
	public currentTime = 0;

	// line-editor
	public inViewId: string;
	public startId: string;
	public endId: string;
	public highlightCanSetInput: 'start' | 'end' | null = null;
	public highlightCanSetInputSubject = new Subject<'start' | 'end' | null >();

	private playerApi: BBPlayerAPI;
	private playerStarted = false;
	private srt: string;

	constructor(
		private sapiService: SapiService
	) {
		this.sapiService.getUrl('/language').subscribe((languageData: any) => {
			if (languageData?.items?.length) {
				this.languagesSubject.next((languageData.items as LanguageItem[]));
			}
		});
	}

	public subtitleChanged(subtitle: Subtitle) {
		this.subtitleSubject.next(subtitle);
	}

	public setUploadedSrt(srt: string) {
		this.uploadedSrtSubject.next(srt);
	}

	public setEditorPlayer(player: BBPlayerAPI): void {
		this.playerStarted = false;
		this.playerApi = player;

		player.on('timeupdate seeking seeked phasechange', () => {
			this.currentTime = Math.round(this.playerApi.getCurrentTime() * 100) / 100; // round to 2 numbers for ms (equal to display in bb-timecode-editor)
			this.currentTimeSubject.next(this.currentTime);

			if (!this.playerStarted && this.currentTime > 0 && this.playerApi.getState() === 'playing') {
				setTimeout(() => {
					this.playerApi.pause();
					this.playerApi.seek(0);
				}, 1);
				this.playerStarted = true;
				this.setPreviewSubtitle(this.srt);
			}
		});
	}

	public setValidInputTimes(inViewId: string, startId: string, endId: string) {
		this.inViewId = inViewId;
		this.startId = startId;
		this.endId = endId;
	}

	public seekTo(seconds: number): void {
		if (!this.playerApi) {
			return;
		}

		this.playerApi.pause();
		this.playerApi.seek(seconds + 0.001); // make sure subtitle is in view
	}

	public setPreviewSubtitle(srt: string): void {
		this.srt = srt;
		if (!this.playerApi) {
			return;
		}

		this.playerApi.setPreviewSubtitleData(srt, 'Realtime preview');
	}

	public setHighlightCanSetInput(field: 'start' | 'end' | null) {
		this.highlightCanSetInput = field;
		this.highlightCanSetInputSubject.next(field);
	}
}
